import React from 'react';
import { OfferBanner } from '../components/OfferBanner';
import { HeroSection } from '../components/HeroSection';
import { EmotionalConnection } from '../components/EmotionalConnection';
import { AvatarPains } from '../components/AvatarPains';
import { ReviewsCarousel } from '../components/ReviewsCarousel';
import { SolutionBenefits } from '../components/SolutionBenefits';
import { ProductOffer } from '../components/ProductOffer';
import { Bonuses } from '../components/Bonuses';
import { BreedGallery } from '../components/BreedGallery';
import { EbookPreview } from '../components/EbookPreview';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen font-body text-deep-brown selection:bg-soft-rose selection:text-white" data-id="element-429">
      <OfferBanner data-id="element-430" />
      <main data-id="element-431">
        <HeroSection data-id="element-432" />
        <EmotionalConnection data-id="element-433" />
        <AvatarPains data-id="element-434" />
        <ReviewsCarousel data-id="element-435" />
        <SolutionBenefits data-id="element-436" />
        <BreedGallery data-id="element-437" />
        <EbookPreview data-id="element-438" />
        <ProductOffer data-id="element-439" />
        <Bonuses data-id="element-440" />
        <Testimonials data-id="element-441" />
        <FAQ data-id="element-442" />
      </main>
      <Footer data-id="element-443" />
      <FloatingCTA data-id="element-444" />
      <PurchasePopup data-id="element-445" />
    </div>;
}